import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";
import axios from "axios";
import "./Style.css";

export default function CreateCompanyDetail({
  showCompanyDetail,
  closeModal,
  refreshPage,
  customerId,
  existingCompanyDetails = [], // Ensure this defaults to an array
}) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [companyDetails, setCompanyDetails] = useState(
    [
      {
        id: null,
        company_name: "",
        location: "",
        contact_person_phone: "",
        country: "",
        state: "",
        city: "",
        email: "",
        area: "",
        industry: "",
        website: "",
        address: "",
      },
    ]
  );

  useEffect(() => {
    if (Array.isArray(existingCompanyDetails) && existingCompanyDetails.length > 0) {
      setCompanyDetails(existingCompanyDetails);
    }
  }, [existingCompanyDetails]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newCompanyDetails = [...companyDetails];
    newCompanyDetails[index][name] = value;
    setCompanyDetails(newCompanyDetails);
  };

  const handleAddCompanyDetail = () => {
    setCompanyDetails([
      ...companyDetails,
      {
        id: null,
        company_name: "",
        location: "",
        contact_person_phone: "",
        country: "",
        state: "",
        city: "",
        email: "",
        area: "",
        industry: "",
        website: "",
        address: "",
      },
    ]);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // Alternative approach using a different API
        const response = await axios.get("https://restcountries.com/v3.1/all?fields=name");
        const countryNames = response.data.map(country => country.name.common).sort();
        setCountries(countryNames);
      } catch (error) {
        console.error("Error fetching countries:", error);
        // Fallback to a static list of common countries
        const fallbackCountries = [
          "Nigeria",
          "United Kingdom", "United States"
        ];
        setCountries(fallbackCountries);
      }
    };

    fetchCountries();
  }, []);

  const handleCountryChange = (index, e) => {
    const selectedCountry = e.target.value;
    const updatedCompanyDetails = [...companyDetails];
    updatedCompanyDetails[index] = {
      ...updatedCompanyDetails[index],
      country: selectedCountry,
      state: "",
      city: "",
    };
    setCompanyDetails(updatedCompanyDetails);

    // Fetch states for the selected country
    fetchStates(selectedCountry);
  };

  const fetchStates = async (countryName) => {
    if (!countryName) {
      setStates([]);
      return;
    }

    // Static state data for common countries
    const countryStates = {
      "United States": [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
        "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
        "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
        "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
        "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
        "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
        "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
        "Wisconsin", "Wyoming"
      ],
      "United Kingdom": [
        "England", "Scotland", "Wales", "Northern Ireland"
      ],

      "Nigeria": [
        "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno",
        "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo", "Jigawa",
        "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger",
        "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
        "Federal Capital Territory"
      ]
    };

    // Set states based on the selected country
    if (countryStates[countryName]) {
      setStates(countryStates[countryName].sort());
    } else {
      setStates([]);
    }
  };

  const handleRemoveCompanyDetail = (index) => {
    setCompanyDetails(companyDetails.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const resetForm = () => {
    setCompanyDetails([
      {
        id: null,
        company_name: "",
        location: "",
        contact_person_phone: "",
        country: "",
        state: "",
        city: "",
        email: "",
        area: "",
        industry: "",
        website: "",
        address: "",
      },
    ]);
    setValidationError({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const data = companyDetails.map((detail) => ({
        ...detail,
        customer_id: customerId,
      }));

      await axiosInstance.post("/user/company/create", { details: data });
      toast.success("Company details saved successfully!");

      handleClose();
      if (refreshPage) refreshPage();
    } catch (error) {
      if (error.response && error.response.data) {
        setValidationError(error.response.data.errors);
        toast.error("Failed to save company details user.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CreateCompanyDetail">
      <Modal
        show={showCompanyDetail}
        onHide={handleClose}
        dialogClassName="modal-lg"
      >
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Company Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="card-body">
              {companyDetails.map((detail, index) => (
                <div
                  key={index}
                  className="mb-4"
                  style={{ border: "1px solid #405189", padding: "1rem" }}
                >
                  <div className="text-center">
                    <b style={{ fontSize: "20px" }}>Company {index + 1}</b>
                  </div>
                  <Form.Group className="mb-3" controlId={`formCompanyName${index}`}>
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="company_name"
                      value={detail.company_name}
                      onChange={(e) => handleChange(index, e)}

                    />
                    {validationError[`details.${index}.company_name`] && (
                      <small className="text-danger my-1">
                        {validationError[`details.${index}.company_name`][0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formEmail${index}`}>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter..."
                      name="email"
                      value={detail.email}
                      onChange={(e) => handleChange(index, e)}

                    />
                    {validationError[`details.${index}.email`] && (
                      <small className="text-danger my-1">
                        {validationError[`details.${index}.email`][0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formCountry${index}`}>
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      as="select"
                      name="country"
                      value={detail.country}
                      onChange={(e) => handleCountryChange(index, e)}

                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                    </Form.Control>
                    {validationError[`details.${index}.country`] && (
                      <small className="text-danger my-1">
                        {validationError[`details.${index}.country`][0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formState${index}`}>
                    <Form.Label>State</Form.Label>
                    <Form.Select
                      name="state"
                      value={detail.state}
                      onChange={(e) => handleChange(index, e)}

                      disabled={!states.length}
                    >
                      <option value="">Select State</option>
                      {states.map((state, i) => (
                        <option key={i} value={state}>
                          {state}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formCity${index}`}>
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="city"
                      value={detail.city}
                      onChange={(e) => handleChange(index, e)}
                    />
                    {validationError.city && (
                      <small className="text-danger my-1">
                        {validationError.city[0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formArea${index}`}>
                    <Form.Label>Area</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="area"
                      value={detail.area}
                      onChange={(e) => handleChange(index, e)}
                    />
                    {validationError.area && (
                      <small className="text-danger my-1">
                        {validationError.area[0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formContactPhone${index}`}>
                    <Form.Label>Contact Person Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="contact_person_phone"
                      value={detail.contact_person_phone}
                      onChange={(e) => handleChange(index, e)}

                    />
                    {validationError[`details.${index}.contact_person_phone`] && (
                      <small className="text-danger my-1">
                        {validationError[`details.${index}.contact_person_phone`][0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formIndustry${index}`}>
                    <Form.Label>Industry</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="industry"
                      value={detail.industry}
                      onChange={(e) => handleChange(index, e)}

                    />
                    {validationError.industry && (
                      <small className="text-danger my-1">
                        {validationError.industry[0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formWebsite${index}`}>
                    <Form.Label>Website</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="website"
                      value={detail.website}
                      onChange={(e) => handleChange(index, e)}
                    />
                    {validationError.website && (
                      <small className="text-danger my-1">
                        {validationError.website[0]}
                      </small>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId={`formAddress${index}`}>
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter..."
                      name="address"
                      value={detail.address}
                      onChange={(e) => handleChange(index, e)}
                    />
                    {validationError.address && (
                      <small className="text-danger my-1">
                        {validationError.address[0]}
                      </small>
                    )}
                  </Form.Group>
                  <div className="d-flex justify-content-center">
                    {index === companyDetails.length - 1 && (
                      <Button
                        className="me-2"
                        variant="secondary"
                        onClick={handleAddCompanyDetail}
                      >
                        Add Another Company
                      </Button>
                    )}
                    {companyDetails.length > 1 && (
                      <Button
                        variant="danger"
                        onClick={() => handleRemoveCompanyDetail(index)}
                      >
                        Remove Company
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={isLoading}>
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
